export * from './hero';
export * from './lyrics-click';
export * from './lyrics-across';
export * from './lyrics-translated';
export * from './lyrics-share';
export * from './lyrics-offline';
export * from './lyrics-search';
export * from './faq';
